import axios from "axios";

import Config from "../../config";

const getListaFunilByChatId = clienteId => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/chat/funil/lista/${clienteId}`
    });
};

export default getListaFunilByChatId;
